import { Switch } from "@/components/ui/switch";
import { Choice, Section } from "@/components/settings/primitives";
import { useUpdateSettings } from "@/hooks/queries";

export function AppearanceSection({ me }) {
  const update = useUpdateSettings();
  const s = me.settings;
  return (
    <div className="space-y-4">
      <Section title="Message text size" description="Adjust the size of text in conversations." testId="settings-text-size-section">
        <Choice
          value={s.text_size}
          onChange={(v) => update.mutate({ text_size: v })}
          options={[{ value: "default", label: "Default" }, { value: "large", label: "Large" }]}
          testIdPrefix="settings-text-size"
        />
      </Section>
      <Section title="Reduced motion" description="Turn off animations and transitions throughout ChatSleek." testId="settings-reduced-motion-section">
        <div className="flex items-center justify-between gap-4">
          <span className="text-sm text-zinc-300">Reduce motion</span>
          <Switch
            checked={s.reduced_motion}
            onCheckedChange={(v) => update.mutate({ reduced_motion: v })}
            data-testid="settings-reduced-motion-switch"
            className="data-[state=checked]:bg-white data-[state=unchecked]:bg-white/15 [&>span]:bg-ink-950 data-[state=unchecked]:[&>span]:bg-zinc-300"
          />
        </div>
      </Section>
      <p className="px-1 text-xs text-zinc-600">ChatSleek is designed dark-first, so there's no light theme.</p>
    </div>
  );
}
